setTimeout(async () => {
  let pillar = await import('@pillar/ng');
  pillar
    .fetchConfig()
    .then(() => import('./bootstrap').catch((err) => console.error(err)));
}, 1);
